<app-loading *ngIf="findOneByIdService.loading$ | async"></app-loading>

<app-form-definition-field-select-filter
        [nbMaxResults]="10"
        [attributeValue]="attributeValue"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        [contextValue]="contextValue"
        [onlyActive]="onlyActive"
        (changeEvent)="change($event)"
        [errorsMessages]="errorsMessages"
        [computed] = computed>
</app-form-definition-field-select-filter>


